import { ISODateString } from '../types';
import { DateTime } from 'luxon';

export const dateIsExpired = (date: ISODateString | undefined) => {
  const expirationDate = DateTime.fromISO(date ?? '');
  const expired = expirationDate.isValid && expirationDate < DateTime.now();
  return expired;
};
